<template>
  <form @submit.prevent="createGuest" class="flex flex-wrap py-4">
    <!-- First Name -->
    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm">
        First Name <span class="text-red-600">*</span>
      </label>
      <input
          v-model="newGuest.first_name"
          :class="['w-full bge-input bge-input-spacing rounded', { 'border-red-500': errors.first_name }]"
          type="text"
          placeholder="First Name..."
      />
      <p v-if="errors.first_name" class="text-red-500 text-xs mt-1">{{ errors.first_name }}</p>
    </div>

    <!-- Last Name -->
    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm">
        Last Name <span class="text-red-600">*</span>
      </label>
      <input
          v-model="newGuest.last_name"
          :class="['w-full bge-input bge-input-spacing rounded', { 'border-red-500': errors.last_name }]"
          type="text"
          placeholder="Last Name..."
      />
      <p v-if="errors.last_name" class="text-red-500 text-xs mt-1">{{ errors.last_name }}</p>
    </div>

    <!-- Company Name -->
    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm">
        Company Name <span class="text-red-600">*</span>
      </label>
      <input
          v-model="newGuest.company_name"
          :class="['w-full bge-input bge-input-spacing rounded', { 'border-red-500': errors.company_name }]"
          type="text"
          placeholder="Company Name..."
      />
      <p v-if="errors.company_name" class="text-red-500 text-xs mt-1">{{ errors.company_name }}</p>
    </div>

    <!-- Email -->
    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm">Email</label>
      <input
          v-model="newGuest.email"
          class="w-full bge-input bge-input-spacing rounded"
          type="email"
          placeholder="Email..."
      />
    </div>

    <!-- Mobile -->
    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm">Mobile</label>
      <input
          v-model="newGuest.mobile"
          class="w-full bge-input bge-input-spacing rounded"
          type="text"
          placeholder="Mobile..."
      />
    </div>

    <!-- Notes -->
    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm">Notes</label>
      <textarea
          v-model="newGuest.notes"
          placeholder="Notes..."
          class="w-full bge-input bge-input-spacing rounded"
          rows="4"
      ></textarea>
    </div>

    <!-- Submit Button -->
    <div class="w-full">
      <button
          type="button"
          @click="createGuest"
          class="float-right mt-5 flex items-center bg-green-200 hover:bg-green-300 text-secondary py-1 px-3 rounded border border-green-400 hover:border-green-500 text-secondary hover:shadow active:shadow-inner transition duration-100"
      >
        <svg
            class="stroke-current h-5 w-5 mr-2"
            fill="none"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            viewBox="0 0 24 24"
        >
          <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
          <path d="M17 21v-8H7v8M7 3v5h8" />
        </svg>
        <span>Create Guest</span>
      </button>
    </div>
  </form>
</template>

<script>
import notificationMixin from "@/mixins/notificationMixin";

export default {
  mixins: [notificationMixin],
  data() {
    return {
      newGuest: {
        first_name: "",
        last_name: "",
        company_name: "",
        email: "",
        mobile: "",
        notes: "",
      },
      errors: {
        first_name: "",
        last_name: "",
        company_name: "",
      },
    };
  },
  methods: {
    validateForm() {
      this.errors = {};

      if (!this.newGuest.first_name)
        this.errors.first_name = "First name is required.";
      if (!this.newGuest.last_name)
        this.errors.last_name = "Last name is required.";
      if (!this.newGuest.company_name)
        this.errors.company_name = "Company name is required.";

      return Object.keys(this.errors).length === 0;
    },

    async createGuest() {
      if (!this.validateForm()) {
        this.notifyError("Please fill all required fields.");
        return;
      }

      try {
        const createdGuest = await this.GuestService.createGuest(this.newGuest);
        this.notifySuccess("Guest created successfully.");

        await this.$router.push({
          name: "guest-edit",
          params: { guest_id: createdGuest.guest_id },
        });
      } catch (err) {
        console.error("Error creating guest:", err);

        if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.message &&
            err.response.data.message.includes("already exists")
        ) {
          this.notifyError("Duplicate entry detected. Please use unique values.");
        } else {
          this.notifyError("Failed to create guest.");
        }

      }
    },
  },
};
</script>

<style scoped>
.text-red-600 {
  color: #dc2626 !important;
}
.border-red-500 {
  border-color: #ef4444 !important;
}
</style>
